(function () {
    'use strict';

    angular
        .module('wizard-english-test')
        .controller('EventController', EventController);

    /** @ngInject */
    function EventController($stateParams) {
        const vm = this;

        vm.event = $stateParams.url;

        console.log(vm.event);
    }
}());